import { createApp } from 'vue'
import App from './App.vue'
import VueSocialSharing from 'vue-social-sharing'
import i18n from './i18n'

/* eslint-disable */
createApp(App).use(VueSocialSharing).use(i18n).mount('#app')
